const apiConfig = {
  //local
  // "baseUrl":"http://localhost:8082",
  // "baseUrlDocument":"http://localhost:8083",
  // "baseUrlMaster":"http://localhost:8082",
  //  "baseUrlReport": "http://localhost:8082",
  //  "baseUrlMasterProject":"http://localhost:8082",
  //  "baseUrlOthers": "http://localhost:8082",
  //  "baseUrlIssue":"http://localhost:8082",
  // "baseUrlMasterWs":"http://localhost:8083",
  //  "baseUrlBoard":"http://localhost:8082",
  //  "baseUrlIdentity": "http://localhost:8082",
  //  "baseUrlSecurity": "http://localhost:8082",
  //  "baseUrlCache":"http://localhost:8096",
  //     "baseUrlTimesheet":"http://localhost:3300",
  //     "baseUrlTimesheet1":"http://localhost:3300",
  //     "baseUrlOldTimesheet":"http://localhost:3300",
  //  "baseUrlAssesments":"http://localhost:8083",
  //  "baseUrlHr":"http://localhost:8099",
  //  "baseUrlBiometic":"http://localhost:8082",
  //  "baseUrlMonitor":"http://localhost:4546",



  //UAT
  "baseUrl": "https://synergy-cf-api.axodesk.com:8081",
  "baseUrlDocument": "https://synergy-cf-api.axodesk.com:8083",
  "baseUrlMaster": "https://synergy-cf-api.axodesk.com:8082",
  "baseUrlReport": "https://synergy-cf-api.axodesk.com:8091",
  "baseUrlMasterProject": "https://synergy-cf-api.axodesk.com:8087",
  "baseUrlOthers": "https://synergy-cf-api.axodesk.com:8089",
  "baseUrlIssue": "https://synergy-cf-api.axodesk.com:8084",
  "baseUrlMasterWs": "https://synergy-cf-api.axodesk.com:8086",
  "baseUrlBoard": "https://synergy-cf-api.axodesk.com:8085",
  "baseUrlIdentity": "https://synergy-cf-api.axodesk.com:8088",
  "baseUrlSecurity": "https://synergy-cf-api.axodesk.com:8090",
  "baseUrlCache": "https://synergy-cf-api.axodesk.com:8096",
  "baseUrlTimesheet": "https://synergy-cf-api.axodesk.com:3000",
  "baseUrlTimesheet1": "https://synergy-cf-api.axodesk.com:3000",
  "baseUrlOldTimesheet": "https://synergy-cf-api.axodesk.com:3000",
  "baseUrlAssesments": "https://synergy-cf-api.axodesk.com:8098",
  "baseUrlBiometic": "https://synergyserver3.coreforce.com:8089",
  "baseUrlMonitor": "https://synergyserver3.coreforce.com:8045",



  //Prod
  // "baseUrl": "https://synergy-api.coreforce.com:8081",
  // "baseUrlDocument": "https://synergy-api.coreforce.com:8083",
  // "baseUrlMaster": "https://synergyserver1.coreforce.com:8082",
  // "baseUrlReport": "https://synergyserver1.coreforce.com:8083",
  // "baseUrlMasterProject": "https://synergyserver1.coreforce.com:8084",
  // "baseUrlOthers": "https://synergyserver1.coreforce.com:8085",
  // "baseUrlIssue": "https://synergyserver2.axodesk.com:8082",
  // "baseUrlMasterWs": "https://synergyserver2.axodesk.com:8083",
  // "baseUrlBoard": "https://synergyserver3.coreforce.com:8082",
  // "baseUrlIdentity": "https://synergyserver4.coreforce.com:8083",
  // "baseUrlSecurity": "https://synergyserver4.coreforce.com:8084",
  // "baseUrlCache": "https://synergy-cache-api.axodesk.com:8096",
  // "baseUrlOldTimesheet": "https://synergy-timesheet2.axodesk.com:8082",
  // "baseUrlTimesheet": "https://synergy-timesheet2.axodesk.com:8082",
  // "baseUrlTimesheet1": "https://synergy-timesheet2.axodesk.com:8082",
  // "baseUrlAssesments": "https://synergyserver3.coreforce.com:8083",
  // "baseUrlBiometic": "https://synergyserver3.coreforce.com:8089",
  // "baseUrlMonitor": "https://synergyserver3.coreforce.com:8045",

  // "gatWayUrl":"https://79a4z7n2g5.execute-api.ap-south-1.amazonaws.com/dev",

  "gatWayUrl": "https://e0olvjr9p5.execute-api.us-east-1.amazonaws.com/prod",
  "socketUrl": "https://synergy-cf.axodesk.com:8097",
  "apiKey": "apiKey",
  "appId": "b0dc92bf-3710-4e11-a87d-4d72585cd281",
  "secrect": "secrect"




}

export default apiConfig;






 